<!--
 * @Description: 首页
 * @Date: 2022-03-10 10:55:42
-->
<template>
  <ul>
    <li v-for="item in list" :key="item.url">
      {{ item.label }}
    </li>
  </ul>
</template>

<script lang="tsx" name="home-index" setup>
const list = [
  { label: '世界各国网址大全', url: 'http://www.world68.com/' },
  { label: 'pmgeek', url: 'https://pmgeek.net/cn/index.html' },
  { label: '站长工具', url: 'https://tool.chinaz.com/' },
  { label: '别看了学不会', url: 'http://www.4243.net/' },
  {
    label: '别看了学不会',
    url: 'https://github.com/azl397985856/leetcode'
  },
  {
    label: '别看了学不会',
    url: 'https://github.com/scutan90/DeepLearning-500-questions'
  },
  {
    label: 'iloveimg 压缩图片 修改图片',
    url: 'https://www.iloveimg.com/zh-cn'
  },
  { label: 'hipdf', url: 'https://www.hipdf.cn/' },
  { label: 'alltoall', url: 'https://www.alltoall.net/' }
];
</script>

<style lang="scss" scoped>
ul {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  li {
    width: 30%;
    margin-bottom: 28px;
  }
}
</style>
